module.exports = __webpack_public_path__ + "static/media/icons-guest-single.ece757d6.svg";